import { createAsyncThunk } from "@reduxjs/toolkit";

import { EndPoints } from "../../api/endpoints";
import axiosClient from "../../api/axiosClient";
import { Exam } from "../apiSlice/examSlice";
import { FilterQueryParams } from "../../forms/FilterForm";

export const getExams = createAsyncThunk(
  "get/exams",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(EndPoints.exams);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const getAtcExams = createAsyncThunk(
  "getAtcExam",
  async (atc_id: string, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(`examinstances/atc/${atc_id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const getAtcUsers = createAsyncThunk(
  "getAtcUsers",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(EndPoints.atcUsers);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const deleteExam = createAsyncThunk(
  "delete/exams",
  async (id: string, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.delete(`${EndPoints.exams}/${id}`);
      dispatch(getExams());
      return { status: response.data.status, id };
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const createExam = createAsyncThunk(
  "create/exams",
  async (data: Exam, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.put(`${EndPoints.exams}`, data);
      dispatch(getExams());
      return { status: response.data.status };
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const updateExam = createAsyncThunk(
  "update/exams",
  async (data: Exam, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.patch(
        `${EndPoints.exams}/${data.id}`,
        data
      );
      dispatch(getExams());
      return { status: response.data.status };
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const filterExam = createAsyncThunk(
  "filter/exams",
  async (queryParams: FilterQueryParams, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(
        `${EndPoints.exams}/filter/?from=${queryParams.from}&to=${queryParams.to}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);
